import * as React from "react";
import classNames from "classnames";
import { IStore } from "../store";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { Button, Grid, Theme, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { AuthActions } from "../store/auth/auth-actions";
import { bindActions, mockTheme } from "../utils/utils";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import LockOutline from "@material-ui/icons/LockOutline";
import Races from "./races";
import Planificacion from "./planificacion";
import PlanificacionMulti from "./planificacionMulti";
import RacesList from "./racesList";
import Visits from "./visits";
import OpportunityList from "./opportunityList";

import Dashboard from "./DashboardPage";
import Client from "./client";
import ClientPage from "./clientPage";
import DriverListPage from "./DriverListPage";
import OpportunityPage from "./opportunityPage";
import Admin from "./admin";
import Messages from "./MessagesPage";
import Branch from "../pages/branch";
import { IUser } from "../utils/userHandler";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import { menu } from "../menu";
import { Route, Switch } from "react-router";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import RacePage from "./RacePage";
import CompanyPage from "./CompanyPage";
import { ConfigData } from "../config";
import DriverPage from "./DriverPage";
import ReportsPage from "./ReportsPage";
import { compose } from "recompose";
import { ArrowBack } from "@material-ui/icons";
import LocationComponent from "src/components/locationComponent";
import DriverDetailPage from "./DriverDetailPage";
import MapImporterComponent from "src/components/MapImporterComponent";
import ReportRacesPage from "./ReportRacesPage";
import RaceDetailSchedule from "src/components/race/RaceDetailSchedule";
import ScheduleRacesList from "src/components/ScheduleRacesList";
// import raceAdd_old from "src/components/race/raceAdd";

const drawerWidth = 240;

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    "& a": {
      textDecoration: "none",
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 1,
  },
  whiteColor: {
    color: "white"
  }
});

const classesType = styles(mockTheme);

interface LayoutProps extends RouteComponentProps<{ id: string }> {
  user: IUser;
  actions: AuthActions;
  classes: ClassNameMap<keyof typeof classesType>;
  config: ConfigData;
}

interface LayoutState {
  open: boolean;
  backOption: boolean;
  consultOpen: boolean;
  cambiar: boolean;
  cambiarRepartos: boolean;
  cambiarReportes: boolean;
  openEnterprise: boolean;
}

const Page404: React.SFC<{}> = () => (
  <div>
    <h3>
      La página que accediste no existe!.
      <Link to="/">volver al Inicio</Link>
    </h3>
  </div>
);

class Layout extends React.Component<LayoutProps, LayoutState> {
  constructor(props: any) {
    super(props);

    this.state = {
      open: true,
      backOption: false,
      consultOpen: false,
      cambiar: false,
      cambiarRepartos: false,
      cambiarReportes: false,
      openEnterprise: false
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.evalRuta = this.evalRuta.bind(this);
  }

  componentDidUpdate(prevProps: Readonly<LayoutProps>, prevState: Readonly<LayoutState>, snapshot?: any): void {
    if (prevProps !== this.props) {
      console.log("Estados: ", prevProps, this.props)
      this.evalRuta();
    }
  }

  handleLogout() {
    this.props.actions.logout();
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  evalRuta() {
    const ruta = this.props.location.pathname;
    // Rutas del menu
    const men = ["/", "/visits/add", "/races/add", "/clients", "/driver", "/admin", "/message", "/company", "/reports", "/opportunity", "/branch"];
    if (men.indexOf(ruta) !== -1) {
      this.setState({ backOption: false });
    }
    else {
      this.setState({ backOption: true });
    }
  }

  public render() {
    const classes = this.props.classes;
    return (
      <div className={classes.root}>
        <AppBar
          position="absolute"
          className={classNames(
            classes.appBar,
            this.state.open && classes.appBarShift
          )}
        >
          <Toolbar disableGutters={!this.state.open}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(
                classes.menuButton,
                this.state.open && classes.hide
              )}
            >
              <MenuIcon />
            </IconButton>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography variant="title" color="inherit" noWrap>
                  {this.props.config.name}
                </Typography>
              </Grid>
              {this.state.backOption && <Grid item alignContent="flex-end">
                <Button onClick={() => this.props.history.goBack()} style={{ padding: 0 }}>
                  <ListItem button title="Volver atras" style={{ padding: 0 }}>
                    <ListItemIcon style={{ margin: 0, color: 'white' }}>
                      <ArrowBack style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Volver atras" classes={{ primary: this.props.classes.whiteColor }} />
                  </ListItem>
                </Button>
              </Grid>}
            </Grid>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !this.state.open && classes.drawerPaperClose
            ),
          }}
          open={this.state.open}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          {menu(
            this.state.consultOpen,
            this.state.cambiarRepartos,
            this.state.openEnterprise,
            this.state.cambiarReportes,
            () => this.setState({ ...this.state, consultOpen: !this.state.consultOpen }),
            () => this.setState({ ...this.state, openEnterprise: !this.state.openEnterprise }),
            () => this.setState({ ...this.state, cambiarRepartos: !this.state.cambiarRepartos }),
            () => this.setState({ ...this.state, cambiarReportes: !this.state.cambiarReportes }),
            this.props.config)
          }

          <Divider />
          <List>
            <ListItem button onClick={this.handleLogout} title="Logout">
              <ListItemIcon>
                <LockOutline />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Drawer>
        <main className={classes.content} style={{width:'100%'}}>
          <div className={classes.toolbar} />
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route path="/clients" component={Client} />
            <Route path="/client/:id" component={ClientPage} />
            <Route path="/admin" component={Admin} />
            <Route path="/message" component={Messages} />

            <Route path="/admin" component={Admin} />
            <Route path="/company" component={CompanyPage} />
            <Route path="/branch" component={Branch} />

            <Route path="/visits/add" component={Visits} />
            <Route path="/visit/:id" component={OpportunityPage} />
            <Route path="/visits" component={OpportunityList} />
            {/* <Route path="/visit/:id" component={VisitPage} /> */}
            <Route path="/races/add" component={Races} />
            <Route path="/race/:id" component={RacePage} />
            <Route path="/races" component={RacesList} />

            <Route path="/driver/:id" component={DriverPage} />
            <Route path="/driver" component={DriverListPage} />
            <Route path="/reports" component={ReportsPage} />
            <Route path="/report-races" component={ReportRacesPage} />
            <Route path="/addlocation" component={LocationComponent} />
            <Route path="/importMap" component={MapImporterComponent} />
            <Route path="/driverDetail" component={DriverDetailPage} />
            <Route path="/schedule-races/" component={ScheduleRacesList} />
            <Route path="/schedule/:id" component={RaceDetailSchedule} />
            <Route path="/planificacion" component={Planificacion} />
            <Route path="/planificacion-multiday" component={PlanificacionMulti} />
            <Route component={Page404} />
          </Switch>
        </main>
      </div>

    );
  }
}

const mapStateToProps = (state: IStore, ownProps: LayoutProps) => ({
  ...ownProps,
  user: state.auth.user,
  config: state.config.data,
});

const styled = withStyles(styles as any);
const connected = connect(mapStateToProps, bindActions(AuthActions));

export default compose(withRouter, connected, styled)(Layout);
// export default connected as ComponentClass<Partial<LayoutProps>>;



// WEBPACK FOOTER //
// ./src/pages/layout.tsx